const ENTITY_TYPE_LABELS = {
  ORG: 'Organization',
  ORGANIZATION: 'Organization',
  CLUB: 'Club',
  COMMUNITY: 'Community',
};

const normalizeEntityTypeKey = (entityType) => String(entityType || '').trim().toUpperCase();

export const getEntityLabel = (entityType, fallback = 'Organization') =>
  ENTITY_TYPE_LABELS[normalizeEntityTypeKey(entityType)] || fallback;

export const resolveEntityType = (...candidates) => {
  const nextType = candidates.find((value) => value !== undefined && value !== null && String(value).trim());
  return normalizeEntityTypeKey(nextType);
};

export { ENTITY_TYPE_LABELS };
